import { createAppSlice } from 'app/createAppSlice'
import {
  getDetailPayable,
  getDetailPayablePersonal,
  getPendingPayable,
  getPendingPayablePersonal,
  getUsersFilterArap,
  getUsersFilterArapPersonal,
} from './payableAction'
import moment from 'moment-timezone'

const endDateDefault = moment().endOf('day').toDate()
const startDateDefault = moment(endDateDefault)
  .subtract(3, 'months')
  .startOf('day')
  .toDate()

const initialState = {
  isOpenBanner: false,
  isOpenSidebar: false,
  tag: {
    size: 10,
    page: 0,
    from: startDateDefault,
    to: endDateDefault,
  },
  tagPersonal: {
    size: 10,
    page: 0,
    from: startDateDefault,
    to: endDateDefault,
  },
  tagPaymentHistory: {
    size: 10,
    page: 0,
    from: startDateDefault,
    to: endDateDefault,
  },
  tagPaymentHistoryPersonal: {
    size: 10,
    page: 0,
    from: startDateDefault,
    to: endDateDefault,
  },
  isOpenModalCategory: false,
  isOpenModalDelete: false,
  isOpenModalAdjust: false,
  detail: null,
  loading: false,
  isOpenModalContacts: false,
  isOpenModalAdjustContacts: false,
  isOpenModalDeleteContact: false,
  isOpenModalConfirm: false,
  bannerMsg: '',
  pendingPayable: [],
  usersFilterArap: null,
  type: 'personal'
}

export const payableNotes = createAppSlice({
  name: 'payableNotes',
  initialState,
  reducers: (create) => ({
    toggleBanner: create.reducer((state) => {
      state.isOpenBanner = !state.isOpenBanner
    }),
    toggleSidebar: create.reducer((state) => {
      state.isOpenSidebar = !state.isOpenSidebar
    }),
    toggleModalCategory: create.reducer((state) => {
      state.isOpenModalCategory = !state.isOpenModalCategory
    }),
    toggleModalDelete: create.reducer((state) => {
      state.isOpenModalDelete = !state.isOpenModalDelete
    }),
    toggleModalAdjust: create.reducer((state) => {
      state.isOpenModalAdjust = !state.isOpenModalAdjust
    }),
    toggleModalContacts: create.reducer((state) => {
      state.isOpenModalContacts = !state.isOpenModalContacts
    }),
    toggleModalAdjustContacts: create.reducer((state) => {
      state.isOpenModalAdjustContacts = !state.isOpenModalAdjustContacts
    }),
    toggleModalDeleteContact: create.reducer((state) => {
      state.isOpenModalDeleteContact = !state.isOpenModalDeleteContact
    }),
    toggleModalConfirm: create.reducer((state) => {
      state.isOpenModalConfirm = !state.isOpenModalConfirm
    }),
    setBannerMsg: create.reducer((state, { payload }) => {
      state.bannerMsg = payload
    }),
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setFetchOptionPersonal: create.reducer((state, { payload }) => {
      state.tagPersonal = { ...state.tagPersonal, ...payload }
    }),
    setFetchOptionPaymentHistory: create.reducer((state, { payload }) => {
      state.tagPaymentHistory = { ...state.tagPaymentHistory, ...payload }
    }),
    setFetchOptionPaymentHistoryPersonal: create.reducer((state, { payload }) => {
      state.tagPaymentHistoryPersonal = { ...state.tagPaymentHistoryPersonal, ...payload }
    }),
    setType: create.reducer((state, { payload }) => {
      state.type = payload
    }),
  }),
  extraReducers: (builder) => {
    builder
      .addCase(getDetailPayable.pending, (state) => {
        state.loading = true
      })
      .addCase(getDetailPayable.fulfilled, (state, { payload }) => {
        state.loading = false
        state.detail = payload
      })
      .addCase(getDetailPayable.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getDetailPayablePersonal.pending, (state) => {
        state.loading = true
      })
      .addCase(getDetailPayablePersonal.fulfilled, (state, { payload }) => {
        state.loading = false
        state.detail = payload
      })
      .addCase(getDetailPayablePersonal.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getPendingPayable.pending, (state) => {
        state.loading = true
      })
      .addCase(getPendingPayable.fulfilled, (state, { payload }) => {
        state.loading = false
        state.pendingPayable = payload
      })
      .addCase(getPendingPayable.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getPendingPayablePersonal.pending, (state) => {
        state.loading = true
      })
      .addCase(getPendingPayablePersonal.fulfilled, (state, { payload }) => {
        state.loading = false
        state.pendingPayable = payload
      })
      .addCase(getPendingPayablePersonal.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getUsersFilterArap.pending, (state) => {
        state.loading = true
      })
      .addCase(getUsersFilterArap.fulfilled, (state, { payload }) => {
        state.loading = false
        state.usersFilterArap = payload
      })
      .addCase(getUsersFilterArap.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getUsersFilterArapPersonal.pending, (state) => {
        state.loading = true
      })
      .addCase(getUsersFilterArapPersonal.fulfilled, (state, { payload }) => {
        state.loading = false
        state.usersFilterArap = payload
      })
      .addCase(getUsersFilterArapPersonal.rejected, (state, { payload }) => {
        state.loading = false
      })
  },
})

export const {
  toggleBanner,
  toggleSidebar,
  setFetchOption,
  toggleModalCategory,
  toggleModalDelete,
  toggleModalAdjust,
  toggleModalContacts,
  toggleModalAdjustContacts,
  toggleModalDeleteContact,
  toggleModalConfirm,
  setBannerMsg,
  setFetchOptionPaymentHistory,
  setType,
  setFetchOptionPersonal,
  setFetchOptionPaymentHistoryPersonal
} = payableNotes.actions

export default payableNotes.reducer
